import { BButton, BCard, BFormGroup, BFormFile } from "bootstrap-vue";

export default {
  components: {
    BButton,
    BCard,
    BFormGroup,
    BFormFile,
  },
  props: {
    value: Array,
  },
  data() {
    return {
      images: [],
      imagesUrl: this.value,
      realValue: this.value,
      deletedProductImages: [],
    };
  },
  watch: {
    value: function(newValue) {
      this.realValue = newValue;
    },
    realValue: function(newValue) {
      this.$emit("input", newValue);
    },
    deletedProductImages: function(newValue) {
      this.$emit("deleted-product-images", newValue);
    },
  },
  methods: {
    onFileChange(e) {
      const filesArr = e.target.files;
      filesArr.forEach((file, index) => {
        this.realValue.push(file);
        // this.imagesUrl.push({
        //   id: index + 1,
        //   url: URL.createObjectURL(file),
        // });
      });
    },
    imgResolver(file) {
      if (file && file.url) {
        return file.url;
      } else {
        return URL.createObjectURL(file);
      }
    },
    deleteFilesItem(file, indx) {
      this.realValue = this.realValue.filter((value, index) => index != indx);
      if (file && file.id) {
        this.deletedProductImages.push(file.id);
      }
    },
  },
};
